<div class="outside-container">
    <div class="container">
        <div class="title">
            <span class="icon">
                <i class="fa-2x fa-fw"
                   [ngClass]="iconClass"
                   aria-hidden="true">
                </i>
            </span>
            <span>
                {{ title }}
            </span>
        </div>
        <div class="container-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
